import { Button } from '@alkem/react-ui-button';
import { Component, ReactNode } from 'react';
import './react-ui-empty-state.scss';

interface Props {
  // This should not exceed around 50 characters
  title: string;
  // This should not exceed around 100 characters
  text: string;
  action: object;
  tips: ReactNode;
  tipsAction: object;
  largeText: boolean;
}

class EmptyState extends Component<Props> {
  public static defaultProps = {
    action: null,
    tips: null,
    largeText: false,
    tipsAction: null,
  };

  private renderAction(action) {
    if (!action) {
      return null;
    }
    return (
      <Button
        className="EmptyState__action"
        content={action.label}
        onClick={action.onClick}
        primary
      />
    );
  }

  private renderTipsAction(tipsAction) {
    if (!tipsAction) {
      return null;
    }
    return (
      <Button
        className="EmptyState__tipsAction"
        content={tipsAction.label}
        onClick={tipsAction.onClick}
        link
      />
    );
  }

  private renderTips(tips) {
    if (!tips) {
      return null;
    }
    return <div className="EmptyState__tips">{tips}</div>;
  }

  public render() {
    const { title, text, action, tips, tipsAction, largeText } = this.props;

    const textClass = largeText ? 'EmptyState__largeText' : 'EmptyState__text';

    return (
      <div className="EmptyState">
        <div className="EmptyState__circle">
          <div className="EmptyState__circleContent">
            <div className="EmptyState__title">{title}</div>
            <div className={textClass}>{text}</div>
            {this.renderAction(action)}
          </div>
        </div>
        {this.renderTips(tips)}
        {this.renderTipsAction(tipsAction)}
      </div>
    );
  }
}

export default EmptyState;
